const breakpoints = {
  xs: 0 + "px",
  sm: 640 + "px",
  md: 768 + "px",
  lg: 1024 + "px",
  xl: 1280 + "px",
  xl2: 1536 + "px",
}
export default breakpoints
